/**
 * 司机管理
 */

export default [
/*  {
    label: '司机管理',
    icon: 'icon-yonghu',
    permission:'driver_manage',
    id:'4',
    children: [*/
      {
        label: '司机管理',
        icon: 'icon-yonghu',
        path: '/driver/manage',
        permission: 'driver_manage',
        id:'4-1',
      }
    /*],
  },*/
];

